// The interval at which the live assignment data is fetched in milliseconds
export const LIVE_ASSIGNMENT_FETCH_INTERVAL = 30_000;
